import loadable from '@loadable/component';

export const OrgDashboardPreviewVolopPageLoadable = loadable(
  () => import('./OrgDashboardPreviewVolopPage'),
  { resolveComponent: (module) => module.OrgDashboardPreviewVolopPage },
);
